import createLucideIcon from '../createLucideIcon';

const ArrowRightCircle = createLucideIcon('ArrowRightCircle', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M8 12h8', key: '1wcyev' }],
  ['path', { d: 'm12 16 4-4-4-4', key: '1i9zcv' }],
]);

export default ArrowRightCircle;
